/**
 * System settings validation logic.
 *
 * Validates site name field for the system settings form.
 */

const MIN_SITE_NAME_LENGTH = 1;
const MAX_SITE_NAME_LENGTH = 128;

export interface ValidationResult {
  readonly valid: boolean;
  readonly error?: string;
}

/**
 * Validates a site name string.
 *
 * Rules:
 * - The trimmed site name must be between 1 and 128 characters inclusive.
 * - Empty strings, whitespace-only strings, and strings exceeding 128 characters
 *   after trimming are rejected.
 *
 * Returns `{ valid: true }` for valid names, or `{ valid: false, error: string }`
 * for invalid names.
 */
export function validateSiteName(name: string): ValidationResult {
  const trimmed = name.trim();

  if (trimmed.length === 0) {
    return { valid: false, error: 'Site name is required' };
  }

  if (trimmed.length > MAX_SITE_NAME_LENGTH) {
    return {
      valid: false,
      error: `Site name must not exceed ${MAX_SITE_NAME_LENGTH} characters`,
    };
  }

  return { valid: true };
}
